import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

function Logo() {
    const showSidebar = useSelector(state => state.showSidebar);
    const dispatch = useDispatch();
    const handleOnclick = () => {
        dispatch({
            type: 'SHOW_SIDEBAR',
            payload: !showSidebar
        });
    };
    return (
        <div className="nav-header">
            <Link to="/bank" className="brand-logo">
                <div
                    className="brand-icon-box"
                    style={{
                        background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 55%, #7c3aed 100%)',
                        border: '1px solid rgba(255,255,255,0.22)',
                        boxShadow: '0 4px 12px rgba(79, 70, 229, 0.35)'
                    }}
                >
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L3 6.5V11.5C3 16.85 6.84 21.74 12 23C17.16 21.74 21 16.85 21 11.5V6.5L12 2Z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="rgba(255,255,255,0.12)" />
                        <path d="M8 9.5H16M12 9.5V16.5M9.5 13.5L12 16.5L14.5 13.5" stroke="#fde047" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <span className="brand-title-text" style={{ letterSpacing: '-0.02em' }}>
                    Bank<span style={{ color: '#4f46e5', fontWeight: 700 }}>TaAnhTu</span>
                </span>
            </Link>
            <div className="nav-control">
                <div
                    className="hamburger toggle-btn-trigger"
                    onClick={handleOnclick}
                    title="Thu gọn / Mở rộng menu"
                >
                    <svg
                        width={17}
                        height={17}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="toggle-btn-trigger"
                    >
                        <path
                            d="M4 6H20M4 12H16M4 18H20"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
}

export default Logo;
